import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  ViewChild,
  ChangeDetectorRef,
  OnDestroy,
  AfterViewInit,
} from "@angular/core";
import { FormBuilder, FormArray, FormGroup, FormControl } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import {
  ConfirmDialogModel,
  ConfirmDialogComponent,
} from "../../shared/components/confirm-dialog/confirm-dialog.component";
import { MatDialog } from "@angular/material";
import { isUndefined, isNullOrUndefined } from "util";

import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from "@angular/material-moment-adapter";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material/core";
import * as _moment from "moment";
import { DatePipe } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { UserService } from "../../shared/service/user.service";
import { BasicEmployeeDetails } from "../../shared/models/basicemployeedetails.model";
import { EmpPreviousEmploymentDetails } from "../../shared/models/hrEmpPrevEmpDtls";
import { EmployeeService } from "../../shared/service/employee.service";
import { OnboardingService } from "../../shared/service/onboarding.service";
import { OnboardHREmpDoc } from "../../shared/models/OnboardHREmpDoc";
import { HREmpMultipleDoc } from "../../shared/models/hrEmpMultipleDocs";
import {
  MultipleFilesDialog,
  MultipleFilesDialogComponent,
} from "../../shared/components/multiple-files-dialog/multiple-files-dialog.component";
import { ComponentIdentificationService } from "../../shared/service/component-identification.service";
import { FileUploadService } from "../../shared/service/fileUpload.service";
import { File_Types } from "../../shared/UploadFileTypes";
import { AppConfig } from "../../app.config";
const moment = _moment;
export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MMM-YYYY",
  },
  display: {
    dateInput: "DD-MMM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: "app-previous-employment",
  templateUrl: "./previous-employment.component.html",
  styleUrls: ["./previous-employment.component.css"],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class PreviousEmploymentComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  prevEmp: FormArray = this.fb.array([]);
  originalPrevEmp = [];
  PriorExperienceYears: number = null;
  PriorExperienceMonths: number = null;
  PrevEmploymentDetForm: FormGroup;
  MAX_SIZE: number = 1048576;
  result: any;
  error: any;
  prevEmploymentDetails: any[] = [];
  @Input() EmpId: number;
  @Input() empCode: number;
  @Output("prevEmpDetValue") prevEmpDetValue = new EventEmitter();
  @Output("referenceDetValue") referenceDetValue = new EventEmitter();
  @Input() isProfile: boolean;
  @Input() isEmpVer: boolean;
  prevEmpDetails: EmpPreviousEmploymentDetails;
  empPreviousEmploymentDetails: EmpPreviousEmploymentDetails;
  originalEmpPreviousEmploymentDetails: EmpPreviousEmploymentDetails;
  // PrevEmpDoc: OnboardHREmpDoc[] = [];
  PrevEmpDocs: any[] = [];
  originalPrevEmpDocs: any[] = [];
  parentComponentName: string;
  showTotalExp = false;
  prevEmpDtlsDisable: boolean = false;
  date: Date;
  todayDate: Date;
  datePipe: DatePipe;
  setDob: string;
  startDate: any;
  minDate: Date;
  datearray: Date[] = [];
  referenceDetails: any[] = [];
  originalReferenceDetails: any[];
  newAttribute: any = {};
  referenceDtlsDisable: boolean = false;
  disableforMyProfile: any;
  LoginEmpCode: any;
  approveCheckMyProfile: any;
  empDOJ: Date;
  totalExpDate: Date;
  prevEmpminDate: Date;
  gettingBasicDet: BasicEmployeeDetails;
  enableReqforFTELoc: boolean = true;
  isLoader: boolean = true;
  monthsOptions: number[] = Array.from({ length: 12 }, (_, i) => i);
  IsValidateTrue: boolean = false;
  isLateral: boolean = false;
  destroyed = false;
  fileInputOpen = false;
  currentDate = new Date()
  TotalExpDate: any;

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private _service: OnboardingService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private userService: UserService,
    private changeCom_svc: ComponentIdentificationService,
    private emp_Svc: EmployeeService,
    public file_Svc: FileUploadService,
    public router: Router,
    private config: AppConfig,
    private dateAdapter: DateAdapter<Date>,
    private cdr: ChangeDetectorRef
  ) {
    this.todayDate = new Date();
  }

  ngOnInit() {
    this.LoginEmpCode = this.userService.getEmpCode();
    this.route.params.subscribe((params) => {
      this.empCode = params["empCode"];
      this.initializeParamChange();
    });
    this.prevEmp = this.fb.array([]);
    this.PriorExperienceYears = null;
    this.PriorExperienceMonths = null;
    this.TotalExpDate = new Date();
   // this.getSubmitMyProfileData();
    //this.getBasicEmployeeByCodeforDate();
    this.PrevEmploymentDetForm = this.fb.group({
      employement: this.prevEmp,
      PriorExperienceYears: [this.PriorExperienceYears],
      PriorExperienceMonths: [this.PriorExperienceMonths],
      TotalExpDate: [this.TotalExpDate],
      TotalExpYears: null,
      TotalExpMonths: null,
    });
    this.PrevEmploymentDetForm.get('employement').valueChanges.subscribe(() => {
      this.cdr.detectChanges();
    });
    //setTimeout(() => {
    //  this.isLoader = false;
    //}, 1000);
  }

  ngAfterViewInit() {
    //this.PrevEmploymentDetForm.get('TotalExpDate').setValue(this.currentDate < this.empDOJ ? this.empDOJ : this.currentDate);
  }

  ngOnDestroy() {
    this.destroyed = true;
  }

  initializeParamChange() {
    //get the login employee code
    this.LoginEmpCode = this.userService.getEmpCode().toString();
    // this.EmpId = this.LoginEmpCode;

    if (!isNullOrUndefined(this.empCode)) {
      if (this.router.url.startsWith("/myprofile/")) {
        if (this.empCode === this.LoginEmpCode) this.isProfile = true;
        else this.router.navigate(["/EmployeeWithoutPermission"]);
      }
    }
  }

  validateNumberInput(event: KeyboardEvent): void {
    const allowedKeys = [
      "Backspace",
      "ArrowLeft",
      "ArrowRight",
      "Delete",
      "Tab",
    ];

    // Allow digits and allowed keys
    if (!/\d/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  getIsValidTrueOutput(val) {
    this.IsValidateTrue = true;
    this.PrevEmploymentDetForm.get("PriorExperienceYears").markAsTouched();
    this.validateAllFormFields(this.PrevEmploymentDetForm.get("employement"));
  }

  validateAllFormFields(formGroup) {
    Object.keys(formGroup.controls).forEach((field, idx) => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched();
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  SetPriorExperience(val) {
    if (val == "Year")
      this.PriorExperienceYears = this.PrevEmploymentDetForm.get(
        "PriorExperienceYears"
      ).value;
    else
      this.PriorExperienceMonths = this.PrevEmploymentDetForm.get(
        "PriorExperienceMonths"
      ).value;
    setTimeout(() => {
      this.setTotalExp();
    });
  }

  GetPriorExperience() {
    const data = {
      prevEmp: this.prevEmp,
      PriorExperienceYears: this.PriorExperienceYears,
      PriorExperienceMonths: this.PriorExperienceMonths,
    };

    return data;
  }
  ngOnChanges() {
    this.changeCom_svc.componentName.subscribe(
      (response) => (this.parentComponentName = response)
    );
    if (this.parentComponentName == "app-hr-employee-details") {
      this.showTotalExp = true;
      if (!isUndefined(this.empCode)) {
        this.GetHREmpPrevEmploymentDetails();
        this.GetHREmpReferences();
        this.getBasicEmployeeByCode();
      } else {
        this.addEmpItem();
        this.addFieldValue();
      }
    } else {
      this.showTotalExp = false;
      this.GetOnboardPrevEmploymentDetails();
      this.GetOnboardEmpReferences();
    }
    this.getBasicEmployeeByCodeforDate();
  }

  addEmpItem(item = null) {
    if (item != null) {
      const row = this.fb.group({
        Id: item.Id,
        CompanyName: item.CompanyName,
        Designation: item.Designation,
        FromDate: item.FromDate,
        ToDate: item.ToDate,
        JobLocation: item.JobLocation,
        onboardVrifications: item.onboardVrifications,
        OnboardHREmpDocs: "",
      });
      this.prevEmp.push(row);
    } else {
      const row = this.fb.group({
        Id: "",
        CompanyName: "",
        Designation: "",
        FromDate: null,
        ToDate: null,
        JobLocation: "",
        onboardVrifications: null,
        OnboardHREmpDocs: null,
      });
      this.prevEmp.push(row);
    }
    if (!this.destroyed)
      this.cdr.detectChanges();
  }
  addFieldValue() {
    this.referenceDetails.push(this.newAttribute);
    this.newAttribute = {};
  }
  deleteFieldValue(index) {
    const message = `Please confirm if you want to delete this Employment?`;
    var deleteType = "Record";
    const dialogData = new ConfirmDialogModel(
      " ",
      message,
      deleteType
    );
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          //this.referenceDetails.splice(index, 1);
          this.prevEmp.value.splice(index, 1);
          this.PrevEmpDocs.splice(index, 1);
          var array = this.prevEmp.value;
          this.prevEmp = this.fb.array([]);
          this.PrevEmploymentDetForm = this.fb.group({
            employement: this.prevEmp,
            PriorExperienceYears: [this.PriorExperienceYears],
            PriorExperienceMonths: [this.PriorExperienceMonths],
            TotalExpDate: [this.TotalExpDate],
            TotalExpYears: null,
            TotalExpMonths: null,
          });
          for (var i = 0; i < array.length; i++) {
            this.addEmpItem(array[i]);
            this.prevEmp.value[i].OnboardHREmpDocs = this.PrevEmpDocs[i];
          }
          this.prevEmpDetValue.emit(this.prevEmp);
          //this.referenceDetValue.emit(this.referenceDetails);
        }
      },
      (error) => {
        this.result = error;
      }
    );
  }

  deleteEmp(index) {
    const message = `Please confirm if you want to delete this Reference?`;
    var deleteType = "Record";
    const dialogData = new ConfirmDialogModel(
      " ",
      message,
      deleteType
    );
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.referenceDetails.splice(index, 1);
          this.referenceDetValue.emit(this.referenceDetails);
        }
      },
      (error) => {
        this.result = error;
      }
    );
  }
  GetOnboardPrevEmploymentDetails() {
    this._service.GetOnboardPrevEmploymentDetails(this.EmpId).subscribe(
      (data: any) => {
        this.prevEmp = this.fb.array([]);
        this.PrevEmploymentDetForm = this.fb.group({
          employement: this.prevEmp,
          PriorExperienceYears: this.PriorExperienceYears || null,
          PriorExperienceMonths: this.PriorExperienceMonths || null,
          TotalExpDate: this.TotalExpDate || new Date(),
          TotalExpYears: null,
          TotalExpMonths: null,
        });
        if (data != null) {
          this.empPreviousEmploymentDetails = data;
          this.originalEmpPreviousEmploymentDetails = JSON.parse(
            JSON.stringify(data)
          );
          this.prevEmploymentDetails = data.onboardEmpPreviousEmploymentDtls;
          this.PriorExperienceYears = data.PriorExperienceYears;
          this.PriorExperienceMonths = data.PriorExperienceMonths;
          this.PrevEmploymentDetForm.patchValue({
            PriorExperienceYears: data.PriorExperienceYears,
            PriorExperienceMonths: data.PriorExperienceMonths,
          });
          if (
            this.prevEmploymentDetails != null &&
            this.prevEmploymentDetails.length > 0
          ) {
            for (var i = 0; i < this.prevEmploymentDetails.length; i++) {
              this.addEmpItem(this.prevEmploymentDetails[i]);
              if (
                !isNullOrUndefined(
                  this.prevEmploymentDetails[i].OnboardHREmpDocs
                ) &&
                this.prevEmploymentDetails[i].OnboardHREmpDocs.length != 0
              ) {
                this.PrevEmpDocs[i] = this.convertOnboardEmpDocType(
                  this.prevEmploymentDetails[i].OnboardHREmpDocs
                );
                this.prevEmp.value[i].OnboardHREmpDocs = this.PrevEmpDocs[i];
              } else {
                this.PrevEmpDocs[i] = [];
              }
            }
          } else {
            this.addEmpItem();
          }
        }
        else {
          this.addEmpItem();
        }
        setTimeout(() => {
          this.setTotalExp();
        })
        this.originalPrevEmp = JSON.parse(JSON.stringify(this.prevEmp.value));
        this.originalPrevEmpDocs = JSON.parse(JSON.stringify(this.PrevEmpDocs));
        this.prevEmpDetValue.emit(this.prevEmp);
      },
      (error) => (this.error = error)
    );
  }

  getObjectState() {
    const originalDetails = this.originalEmpPreviousEmploymentDetails;
    const currentDetails = this.empPreviousEmploymentDetails;
    this.assignDocumentsListToObject();
    originalDetails.hrEmpPreviousEmploymentDtls = this.originalPrevEmp;
    currentDetails.hrEmpPreviousEmploymentDtls = this.prevEmp.value;
    var EmpVal =
      JSON.stringify(originalDetails) === JSON.stringify(currentDetails);
    this.referenceDetails = this.referenceDetails.filter(obj => Object.keys(obj).length > 0);
    this.referenceDetails = this.referenceDetails.length == 0 ? null : this.referenceDetails;
    this.originalReferenceDetails = this.originalReferenceDetails == undefined ? null : this.originalReferenceDetails;
    const originalRef = this.originalReferenceDetails;
    const ref = this.referenceDetails;
    var RefVal = JSON.stringify(originalRef) === JSON.stringify(ref);
    return !(EmpVal && RefVal);
  }

  getRefreshPage() {
    window.location.reload();
  }

  GetHREmpPrevEmploymentDetails() {
    this.emp_Svc.getEmployeePreviousEmploymentDetails(this.empCode).subscribe(
      (data: any) => {
        this.prevEmp = this.fb.array([]);
        this.PrevEmploymentDetForm = this.fb.group({
          employement: this.prevEmp,
          PriorExperienceYears: this.PriorExperienceYears || null,
          PriorExperienceMonths: this.PriorExperienceMonths || null,
          TotalExpDate: this.TotalExpDate || new Date(),
          TotalExpYears: null,
          TotalExpMonths: null,
        });
        if (data != null) {
          this.empPreviousEmploymentDetails = data;
          this.originalEmpPreviousEmploymentDetails = JSON.parse(
            JSON.stringify(data)
          );
          this.prevEmploymentDetails = data.hrEmpPreviousEmploymentDtls;
          this.PriorExperienceYears = data.PriorExperienceYears;
          this.PriorExperienceMonths = data.PriorExperienceMonths;
          this.PrevEmploymentDetForm.patchValue({
            PriorExperienceYears: data.PriorExperienceYears,
            PriorExperienceMonths: data.PriorExperienceMonths,
          });
          if (
            this.prevEmploymentDetails != null &&
            this.prevEmploymentDetails.length > 0
          ) {
            for (var i = 0; i < this.prevEmploymentDetails.length; i++) {
              this.addEmpItem(this.prevEmploymentDetails[i]);
              if (
                !isNullOrUndefined(this.prevEmploymentDetails[i].HREmpDocs) &&
                this.prevEmploymentDetails[i].HREmpDocs.length != 0
              ) {
                this.PrevEmpDocs[i] = this.convertHrEmpDocType(
                  this.prevEmploymentDetails[i].HREmpDocs
                );
                this.prevEmp.value[i].OnboardHREmpDocs = this.PrevEmpDocs[i];
              } else {
                this.PrevEmpDocs[i] = [];
              }
            }
          } else {
            this.addEmpItem();
          }
        }
        setTimeout(() => {
          this.setTotalExp();
        })
        this.originalPrevEmp = JSON.parse(JSON.stringify(this.prevEmp.value));
        this.originalPrevEmpDocs = JSON.parse(JSON.stringify(this.PrevEmpDocs));
        this.prevEmpDetValue.emit(this.prevEmp);
      },
      (error) => (this.error = error)
    );
  }


  reset() {
    this.PrevEmpDocs = [];
  }
  convertOnboardEmpDocType(array: any[]) {
    let arr: any[] = [];
    array.forEach((item) => {
      let docItem = new OnboardHREmpDoc();
      docItem.ID = item.ID;
      docItem.EmpId = item.EmpId;
      docItem.DocNumber = item.DocNumber;
      docItem.DocumentPath = item.DocumentPath;
      docItem.HRDocTypeId = item.HRDocTypeId;
      docItem.DocumentName = item.DocumentName;
      docItem.ModifiedBy = item.ModifiedBy;
      docItem.ModifiedDate = item.ModifiedDate;
      docItem.PreviousEmploymentDetailsID = item.PreviousEmploymentDetailsID;
      docItem.File = {
        fileName: "",
        fileSize: 0,
        fileType: "",
        lastModifiedTime: 0,
        lastModifiedDate: new Date(),
        fileAsBase64: "",
      };
      arr = arr.concat(docItem);
    });
    return arr;
  }
  GetOnboardEmpReferences() {
    this.referenceDetails = [];
    this._service.GetOnboardEmpReferences(this.EmpId).subscribe(
      (data: any) => {
        if (data != null && data.length != 0) {
          this.referenceDetails = data;
          this.originalReferenceDetails = JSON.parse(JSON.stringify(data));
        } else {
          this.addFieldValue();
        }
        this.referenceDetValue.emit(this.referenceDetails);
      },
      (error) => (this.error = error)
    );
  }
  getBasicEmployeeByCode() {
    this.emp_Svc.getBasicEmployeeById(this.empCode).subscribe((data: any) => {
      this.gettingBasicDet = data;
      var doj = this.gettingBasicDet.DOJ != null ? new Date(this.gettingBasicDet.DOJ) : this.gettingBasicDet.DOJ;
      this.TotalExpDate = this.currentDate < doj ? doj : this.currentDate;
      if (this.gettingBasicDet.ConsultantType == "SubCon") {
        this.enableReqforFTELoc = false;
      } else {
        if (
          this.gettingBasicDet.LocationID != 1 &&
          this.gettingBasicDet.LocationID != 2
        ) {
          this.enableReqforFTELoc = false;
        } else {
          this.enableReqforFTELoc = true;
        }
      }
      if (!this.destroyed)
        this.cdr.detectChanges();
    });
  }
  GetHREmpReferences() {
    this.referenceDetails = [];
    this.emp_Svc.getEmployeeReferenceDetails(this.empCode).subscribe(
      (data: any) => {
        if (data != null && data.length != 0) {
          this.referenceDetails = data;
          this.originalReferenceDetails = JSON.parse(JSON.stringify(data));
        } else {
          this.addFieldValue();
        }
        this.referenceDetValue.emit(this.referenceDetails);
      },
      (error) => (this.error = error)
    );
  }
  convertHrEmpDocType(array: any[]) {
    let arr: any[] = [];
    array.forEach((item) => {
      let docItem = new HREmpMultipleDoc();
      docItem.ID = item.ID;
      docItem.EmpCode = item.EmpCode;
      docItem.DocNumber = item.DocNumber;
      docItem.DocumentPath = item.DocumentPath;
      docItem.HRDocTypeId = item.HRDocTypeId;
      docItem.DocumentName = item.DocumentName;
      docItem.ModifiedBy = item.ModifiedBy;
      docItem.ModifiedDate = item.ModifiedDate;
      docItem.oldId = true;
      docItem.PreviousEmploymentDetailsID = item.PreviousEmploymentDetailsID;
      arr = arr.concat(docItem);
    });
    return arr;
  }

  setTotalExp() {
    if (this.empCode != null && this.parentComponentName == "app-hr-employee-details") {
      this.emp_Svc.getBasicEmployeeById(this.empCode).subscribe((data: any) => {

        this.empDOJ = data != null && data.DOJ != null ? new Date(data.DOJ) : new Date();
        var totalExpDate = new Date(
          this.PrevEmploymentDetForm.get("TotalExpDate").value
        );
        var PriorExperienceYears = this.PriorExperienceYears != null ? this.PriorExperienceYears : 0;
        var PriorExperienceMonths = this.PriorExperienceMonths != null ? this.PriorExperienceMonths : 0;
        let totalPriorMonths = PriorExperienceYears * 12 + PriorExperienceMonths;
        let totalWWExpMonths = data != null && data.DOJ != null ?
          (totalExpDate.getFullYear() - this.empDOJ.getFullYear()) * 12 +
          (totalExpDate.getMonth() - this.empDOJ.getMonth()) : 0;
        let TotalExp = totalPriorMonths + totalWWExpMonths;
        this.PrevEmploymentDetForm.get("TotalExpYears").setValue(
          Math.floor(TotalExp / 12)
        );
        this.PrevEmploymentDetForm.get("TotalExpMonths").setValue(TotalExp % 12);
      });
      this.isLoader = false;
    }
    else {
      if (this.EmpId != null) {
        this._service.getEmployeebyId(this.EmpId).subscribe((data: any) => {

          this.empDOJ = data != null && data.DOJ != null ? new Date(data.DOJ) : new Date();
          var totalExpDate = new Date(
            this.PrevEmploymentDetForm.get("TotalExpDate").value
          );
          var PriorExperienceYears = this.PriorExperienceYears != null ? this.PriorExperienceYears : 0;
          var PriorExperienceMonths = this.PriorExperienceMonths != null ? this.PriorExperienceMonths : 0;
          let totalPriorMonths = PriorExperienceYears * 12 + PriorExperienceMonths;
          let totalWWExpMonths = data != null && data.DOJ != null ?
            (totalExpDate.getFullYear() - this.empDOJ.getFullYear()) * 12 +
            (totalExpDate.getMonth() - this.empDOJ.getMonth()) : 0;
          let TotalExp = totalPriorMonths + totalWWExpMonths;
          this.PrevEmploymentDetForm.get("TotalExpYears").setValue(
            Math.floor(TotalExp / 12)
          );
          this.PrevEmploymentDetForm.get("TotalExpMonths").setValue(TotalExp % 12);
        });
        this.isLoader = false;
      }
    }
    if (!this.destroyed)
      this.cdr.detectChanges();
  }

  fileCancel(i, j) {
    const message = `Please confirm if you want to remove this Attachment?`;
    var deleteType = "Attachment";
    const dialogData = new ConfirmDialogModel(
      " ",
      message,
      deleteType
    );
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          var element = this.PrevEmpDocs[i].splice(j, 1);
          if (element[0].DocumentPath != null) {
            if (!isUndefined(this.empCode)) {
              this.emp_Svc.DeleteFileinMultipleFiles(element[0].ID).subscribe();
            } else {
              this._service
                .DeleteFileinMultipleFiles(element[0].ID)
                .subscribe();
            }
          }
          this.prevEmp.value[i].OnboardHREmpDocs = this.PrevEmpDocs[i];
          if (this.PrevEmpDocs[i].length < 1) {
            this.prevEmp.value[i].OnboardHREmpDocs = null;
          }
          this.toastr.success("Deleted Successfully");
        }
      },
      (error) => {
        this.result = error;
      }
    );
  }
  FilesUploadDialogBox(index) {
    const message = this.prevEmp.value[index];
    var screenName = "PrevEmpTab";
    const dialogData = new MultipleFilesDialog(
      "Files Action",
      message,
      screenName,
      this.empCode,
      this.prevEmp.value[index].OnboardHREmpDocs != null && this.prevEmp.value[index].OnboardHREmpDocs != "" ? this.prevEmp.value[index].OnboardHREmpDocs.length : 0,
      null,
    );
    const dialogRef = this.dialog.open(MultipleFilesDialogComponent, {
      maxWidth: "600px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult != false) {
          if (this.PrevEmpDocs[index] != null) {
            this.PrevEmpDocs[index] =
              this.PrevEmpDocs[index].concat(dialogResult);
            this.prevEmp.value[index].OnboardHREmpDocs =
              this.PrevEmpDocs[index];
            this.cdr.detectChanges();
          } else {
            this.PrevEmpDocs[index] = dialogResult;
            this.prevEmp.value[index].OnboardHREmpDocs =
              this.PrevEmpDocs[index];
            this.cdr.detectChanges();
          }
        }
      },
      (error) => {
        this.result = error;
      }
    );
  }

  cancelFile(event, index, file, idx) {
    this.PrevEmpDocs[index][idx].File = null;
    this.prevEmp.value[index].OnboardHREmpDocs = this.PrevEmpDocs[index];
    this.toastr.error("file removed successfully");
  }

  async handleFile(event, index, file, idx) {
    ;
    if (event.target.files == undefined) {
      this.PrevEmpDocs[index] = null;
    }
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      if (!this.validFileType(files[0])) {
        this.toastr.warning(
          "File name " + files[0].name + ": Not a valid file type."
        );
        // Clear the input
        event.srcElement.value = null;
        event.currentTarget.value = null;
      }
      // Don't allow file sizes over 1MB
      if (files[0].size < this.MAX_SIZE) {
        this.PrevEmpDocs[index][idx].File =
          await this.file_Svc.readAndUploadFile(files);
        this.PrevEmpDocs[index][idx].DocumentPath = null;
        this.prevEmp.value[index].OnboardHREmpDocs = this.PrevEmpDocs[index];
        //delete this.PrevEmpDocs[index][idx].file.DocumentPath;
      } else {
        this.toastr.warning(
          " File: " +
          files[0].name +
          " exceeds 1MB hence it cannot be uploaded."
        );
        // Clear the input
        event.srcElement.value = null;
        event.currentTarget.value = null;
      }
      //console.log(this.PrevEmpDocs[index])
    }
  }
  //check the file types
  validFileType(file) {
    let types = File_Types;
    return types.includes(file.type);
  }

  //displayDate(event) {
  //  //console.log(event);
  //  //this.startDate = event;
  //  //console.log(this.startDate.add(1, 'days'));
  //  event.add(1, 'days')
  //}
  //dateRange1 = [new Date("09-01-2019"), new Date("09-02-2019")]
  //dateRange2 = [new Date("09-05-2019"), new Date("09-18-2019")]
  //myFilter = (d: Date): boolean => {
  //  // Prevent dates in ranges from being selected.
  //  return !(d >= this.prevEmp.value[0].FromDate && d <= this.prevEmp.value[0].ToDate)

  //}
  //dateChanges(index) {
  //  if (index > 0) {
  //    return !(d >= this.prevEmp.value[0].FromDate && d <= this.prevEmp.value[0].ToDate)
  //  }

  //}
  //myFilter = (d: Date): boolean => {
  //  // Prevent dates in ranges from being selected.
  //  if (this.prevEmp.value.length != undefined && this.prevEmp.value.length != null && this.prevEmp.value.length != 0) {
  //    for (var i = 0; i < this.prevEmp.value.length; i++) {
  //      return !(d >= this.prevEmp.value[i].FromDate && d <= this.prevEmp.value[i].ToDate)
  //    }
  //  }

  //}
  assignDocumentsListToObject() {
    for (var i = 0; i < this.PrevEmpDocs.length; i++) {
      this.prevEmp.value[i].OnboardHREmpDocs = this.PrevEmpDocs[i];
    }
  }
  getSubmitMyProfileData() {
    this.emp_Svc
      .GetProfileVerificationStatus(this.LoginEmpCode)
      .subscribe((data: any) => {
        this.approveCheckMyProfile = data;
        if (this.isProfile == true) {
          for (var i = 0; i < data.length; i++) {
            this.disableforMyProfile = data[i].Submitted;
          }
        }
        if (this.disableforMyProfile == true) {
          this.PrevEmploymentDetForm.disable();
        }
      });
  }

  openFileDialog(fileInput: any) {
    if (!this.fileInputOpen) {
      this.fileInputOpen = true;
      fileInput.open();
    }
  }

  getBasicEmployeeByCodeforDate() {
    if (this.empCode != null) {
      this.emp_Svc.getBasicEmployeeById(this.empCode).subscribe((data: any) => {
        this.empDOJ = data.DOJ;
        this.empDOJ = new Date(data.DOJ);
        const fromYear = this.empDOJ.getFullYear();
        const fromMonth = this.empDOJ.getMonth();
        const fromDate = this.empDOJ.getDate();
        this.prevEmpminDate = new Date(fromYear, fromMonth, fromDate - 1);
      });
    }

    else {
      this._service.getEmployeebyId(this.EmpId).subscribe((data: any) => {
        this.empDOJ = data.DOJ;
        this.empDOJ = new Date(data.DOJ);
        const fromYear = this.empDOJ.getFullYear();
        const fromMonth = this.empDOJ.getMonth();
        const fromDate = this.empDOJ.getDate();
        this.prevEmpminDate = new Date(fromYear, fromMonth, fromDate - 1);
        this.isLateral = data && data.HiringType === "Lateral" ? true : false;
      });
    }
    this.cdr.detectChanges();
    return this.prevEmpminDate;
  }

  setToDateofPreviousEmployment(fromDateofJoining: Date, index) {
    this.prevEmp.value[index].FromDate = fromDateofJoining;
    this.prevEmp.value[index].FromDate = new Date(fromDateofJoining);
    const fromYear = this.prevEmp.value[index].FromDate.getFullYear();
    const fromMonth = this.prevEmp.value[index].FromDate.getMonth();
    const fromDate = this.prevEmp.value[index].FromDate.getDate();
    this.datearray[index] = new Date(fromYear, fromMonth, fromDate + 1);
    this.cdr.detectChanges();
  }

  markDatesAsTouched() {
    this.prevEmp.controls.forEach(group => {
      const formGroup = group as FormGroup;
      const fromDateControl = formGroup.get('FromDate');
      const toDateControl = formGroup.get('ToDate');
      if (fromDateControl) {
        fromDateControl.markAsTouched();
      }
      if (toDateControl) {
        toDateControl.markAsTouched();
      }
    });

    setTimeout(() => {
      this.cdr.detectChanges();
    }, 0);
  }

  detectChanges() {
    this.cdr.detectChanges();
  }

  fetchURl(url) {
    this.emp_Svc
      .getDownloadURL(url)
      .subscribe((data: any) => {
        window.open(data, '_blank');
      });
  }
}
